<template>
  <v-dialog :value="value" width="500px" @input="$emit('input', $event)">
    <v-card>
      <v-card-title> Upload finalizado </v-card-title>
      <v-card-text class="pb-0">
        <ul>
          <li>{{ status.uncategorized_products }} produtos movidos para a categoria geral.</li>
          <li>{{ status.products_without_images }} produtos sem imagem.</li>
          <li>{{ status.altered_prices }} preços alterados.</li>
          <li>{{ status.products_removed }} produtos removidos do Televendas.</li>
          <li>{{ status.matched_products }} produtos encontrados no banco.</li>
          <li>{{ status.unmatched_products }} produtos não encontrados no banco.</li>
        </ul>
      </v-card-text>
      <mf-action-buttons
        :primary-button="{
          text: 'Fechar',
          action: closeDialog,
          isVisible: true,
        }"
      />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    status: Object,
  },
  methods: {
    closeDialog() {
      this.$emit('input', false)
    },
  },
}
</script>

<style></style>
